import React from "react"
import HeaderComponent from "../Header/component"
import FooterComponent from "../Footer/component"

import "./styles.scss"

export default function NewsComponent() {
  return (
    <>
      <HeaderComponent />

      <main id="main" className="site-main">
        <div id="page-title" className="page-title-ml">
          <div className="wrapper">
            <div className="title">
              <h1 className="large">Our News</h1>
            </div>

            <div className="title-opacity">
              <div className="title-opacity-text">News</div>
            </div>
          </div>
        </div>

        <div id="page-content" className="spacer p-top-xl">
          <div className="wrapper">
            <div className="content">
              <div id="blog">
                <div className="row gutter-width-md">
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                    <div className="row gutter-width-md with-pb-lg">
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="5 Tips for Sustainable Business Success"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/20_img.jpg"
                                    alt="5 Tips for Sustainable Business Success"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="5 Tips for Sustainable Business Success"
                                href="news-single-post.html"
                              >
                                5 Tips for Sustainable Business Success
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="Assessing the Maturity of Your Data Management in Industry"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/21_img.jpg"
                                    alt="Assessing the Maturity of Your Data Management in Industry"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="Assessing the Maturity of Your Data Management in Industry"
                                href="news-single-post.html"
                              >
                                Assessing the Maturity of Your Data Management
                                in Industry
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="How to Build Your Sustainable Susiness Strategy"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/22_img.jpg"
                                    alt="How to Build Your Sustainable Susiness Strategy"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="How to Build Your Sustainable Susiness Strategy"
                                href="news-single-post.html"
                              >
                                How to Build Your Sustainable Susiness Strategy
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="5 Tips for Sustainable Business Success"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/20_img.jpg"
                                    alt="5 Tips for Sustainable Business Success"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="5 Tips for Sustainable Business Success"
                                href="news-single-post.html"
                              >
                                5 Tips for Sustainable Business Success
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="Assessing the Maturity of Your Data Management in Industry"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/21_img.jpg"
                                    alt="Assessing the Maturity of Your Data Management in Industry"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="Assessing the Maturity of Your Data Management in Industry"
                                href="news-single-post.html"
                              >
                                Assessing the Maturity of Your Data Management
                                in Industry
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="How to Build Your Sustainable Susiness Strategy"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/22_img.jpg"
                                    alt="How to Build Your Sustainable Susiness Strategy"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="How to Build Your Sustainable Susiness Strategy"
                                href="news-single-post.html"
                              >
                                How to Build Your Sustainable Susiness Strategy
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="5 Tips for Sustainable Business Success"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/20_img.jpg"
                                    alt="5 Tips for Sustainable Business Success"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="5 Tips for Sustainable Business Success"
                                href="news-single-post.html"
                              >
                                5 Tips for Sustainable Business Success
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <div className="card card-post">
                          <div className="card-top position-relative">
                            <a
                              title="Assessing the Maturity of Your Data Management in Industry"
                              href="news-single-post.html"
                            >
                              <div className="img object-fit overflow-hidden">
                                <div className="object-fit-cover transform-scale-h">
                                  <img
                                    className="card-top-img"
                                    src="assets/img/demo/21_img.jpg"
                                    alt="Assessing the Maturity of Your Data Management in Industry"
                                  />
                                </div>
                              </div>
                            </a>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">
                              <a
                                title="Assessing the Maturity of Your Data Management in Industry"
                                href="news-single-post.html"
                              >
                                Assessing the Maturity of Your Data Management
                                in Industry
                              </a>
                            </h5>

                            <p className="card-text">
                              At vero eos et accusamus et iusto odio dignissimos
                              ducims…
                            </p>

                            <div className="card-btn">
                              <a
                                title="Read more"
                                className="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                                href="news-single-post.html"
                              >
                                <i className="malex-icon-arrow-right i-large"></i>
                                <span className="btn-text">Read more</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="loadmore spacer m-top-lg">
                      <a
                        title="Load More"
                        className="btn btn-outline-secondary"
                        href="#"
                      >
                        Load More
                      </a>
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                    <aside id="aside" className="widget-area">
                      <div className="widget widget_search">
                        <form
                          className="search-form"
                          role="search"
                          method="get"
                          action="https://store.adveits.com/project/malex/html/demo/search-results.html"
                        >
                          <div className="search input-group">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              placeholder="Search"
                              name="s"
                            />

                            <div className="input-group-append">
                              <button
                                type="submit"
                                className="btn btn-link border-0 p-0 min-w-auto"
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div className="widget widget_categories">
                        <h6 className="widget-title">Categories</h6>

                        <ul>
                          <li className="cat-item">
                            <a title="Strategy" href="news.html">
                              Strategy
                            </a>
                          </li>

                          <li className="cat-item">
                            <a title="Sales" href="news.html">
                              Sales
                            </a>
                          </li>

                          <li className="cat-item">
                            <a title="Marketing" href="news.html">
                              Marketing
                            </a>
                          </li>

                          <li className="cat-item">
                            <a title="Business" href="news.html">
                              Business
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="widget widget_recent_entries">
                        <h6 className="widget-title">Recent posts</h6>

                        <ul className="list-unstyled items">
                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/20_img.jpg"
                                        alt="5 Tips for Sustainable Business Success"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="5 Tips for Sustainable Business Success"
                                    href="news-single-post.html"
                                  >
                                    5 Tips for Sustainable Business Success
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>

                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/21_img.jpg"
                                        alt="Assessing the Maturity of Your Data Management in Industry"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="Assessing the Maturity of Your Data Management in Industry"
                                    href="news-single-post.html"
                                  >
                                    Assessing the Maturity of Your Data
                                    Management in Industry
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>

                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/22_img.jpg"
                                        alt="How to Build Your Sustainable Susiness Strategy"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="How to Build Your Sustainable Susiness Strategy"
                                    href="news-single-post.html"
                                  >
                                    How to Build Your Sustainable Susiness
                                    Strategy
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>

                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/20_img.jpg"
                                        alt="5 Tips for Sustainable Business Success"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="5 Tips for Sustainable Business Success"
                                    href="news-single-post.html"
                                  >
                                    5 Tips for Sustainable Business Success
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="widget widget_recent_comments">
                        <h6 className="widget-title">Recent Comments</h6>

                        <ul id="recentcomments">
                          <li className="recentcomments">
                            <span className="comment-author-link">
                              Tommy Andersen
                            </span>{" "}
                            on
                            <a
                              title="Tommy Andersen"
                              href="news-single-post.html#comments"
                            >
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit…
                            </a>
                          </li>

                          <li className="recentcomments">
                            <span className="comment-author-link">
                              Rosie Ford
                            </span>{" "}
                            on
                            <a
                              title="Rosie Ford"
                              href="news-single-post.html#comments"
                            >
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit…
                            </a>
                          </li>

                          <li className="recentcomments">
                            <span className="comment-author-link">
                              Arthur Hopin
                            </span>{" "}
                            on
                            <a
                              title="Arthur Hopin"
                              href="news-single-post.html#comments"
                            >
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit…
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="widget widget_tag_cloud">
                        <h6 className="widget-title">Tags</h6>

                        <div className="tagcloud">
                          <a
                            title="Strategy"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Strategy
                          </a>
                          <a
                            title="Marketing"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Marketing
                          </a>
                          <a
                            title="Sales"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Sales
                          </a>
                          <a
                            title="Business"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Business
                          </a>
                        </div>
                      </div>
                    </aside>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <FooterComponent />
    </>
  )
}
